/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_LedeInputs */

const en_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every field you send and every field you get back, each with a real example.`)
};

const zh_hans1_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你发送的每个字段和收到的每个字段，都附有真实示例。`)
};

const pt_br2_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada campo que você envia e cada campo que você recebe, cada um com um exemplo real.`)
};

const es_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada campo que envías y cada campo que recibes, cada uno con un ejemplo real.`)
};

const fr_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque champ que vous envoyez et chaque champ que vous recevez, avec un vrai exemple.`)
};

const de_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes Feld, das du sendest, und jedes Feld, das du zurückbekommst, jeweils mit einem echten Beispiel.`)
};

const ru_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждое поле, которое вы отправляете, и каждое поле, которое получаете, с реальным примером.`)
};

const it_endpoint_reference_lede = /** @type {(inputs: Endpoint_Reference_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni campo che invii e ogni campo che ricevi, ciascuno con un esempio reale.`)
};

/**
* | output |
* | --- |
* | "Every field you send and every field you get back, each with a real example." |
*
* @param {Endpoint_Reference_LedeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_lede = /** @type {((inputs?: Endpoint_Reference_LedeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_LedeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_lede(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_lede(inputs)
	if (locale === "es") return es_endpoint_reference_lede(inputs)
	if (locale === "fr") return fr_endpoint_reference_lede(inputs)
	if (locale === "de") return de_endpoint_reference_lede(inputs)
	if (locale === "ru") return ru_endpoint_reference_lede(inputs)
	if (locale === "it") return it_endpoint_reference_lede(inputs)
	return en_endpoint_reference_lede(inputs)
});